import React, { useEffect, useState } from "react";
import Gauche from "../home/gauche";
import Discussion from "./discussion";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import { format } from "date-fns";
import fr from "date-fns/locale/fr";
import { baseApiUrl } from "../../../services/api";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

function Forum() {
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(3);
  const [informations, setInformations] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Colors for consistent styling - can be adjusted to match your theme
  const colors = {
    primary: "#0075FF",
    secondary: "#F5A623",
    tertiary: "#333333",
    border: "#e0e0e0",
    light: "#f9f9f9"
  };

  // Calculer les informations à afficher sur la page actuelle
  const offset = currentPage * itemsPerPage;
  const currentInformations = informations.slice(offset, offset + itemsPerPage);

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, "dd MMMM yyyy", { locale: fr });
    } catch {
      return "Date invalide";
    }
  };

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      const results = informations.filter(info =>
        info.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (info.contenu && info.contenu.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setSearchResults(results);
      setShowSearchResults(true);
    } else {
      setShowSearchResults(false);
    }
  };

  const navigateToInformation = (id) => {
    navigate(`/information/${id}`);
  };

  useEffect(() => {
    setLoading(true);
    // Récupérer les informations depuis l'API
    baseApiUrl
      .get("/information/liste")
      .then((response) => {
        setInformations(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des informations :", error);
        setInformations([]);
        setLoading(false);
      });
  }, []);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
    window.scrollTo(0, 0); // Scroll back to top when changing page
  };

  return (
    <forum>
      <Header />
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: window.innerWidth < 768 ? "100px" : "200px",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-heading">
                <h1>Forums</h1>
                <h3 style={{ fontSize: "18px", color: "white" }}>
                  Le forum c'est l'espace ou chaque acteur peut dicuter avec les
                  autres auteurs sur des thematiques precis.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog1 sp bg1 _relative">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <Discussion />
            </div>

            <div className="col-lg-4">
              <div className="blog1-sidebar-area ml-30 sm:ml-0 md:ml-0 md:mt-30 sm:mt-30">
                {/* Recherche */}
                <div className="sidebar-details-widget_1 _search-area1">
                  <h3 style={{ color: colors.primary }}>Rechercher</h3>
                  <form onSubmit={handleSearch}>
                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        placeholder="Rechercher..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          borderColor: colors.border,
                          padding: "10px 40px 10px 15px",
                          borderRadius: "5px",
                          width: "100%"
                        }}
                      />
                      <button
                        type="submit"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: colors.primary
                        }}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </form>

                  {/* Résultats de recherche */}
                  {showSearchResults && (
                    <div style={{
                      marginTop: "15px",
                      border: `1px solid ${colors.border}`,
                      borderRadius: "5px",
                      padding: "15px",
                      backgroundColor: colors.light
                    }}>
                      <h4 style={{ color: colors.tertiary, marginBottom: "10px" }}>
                        Résultats de recherche ({searchResults.length})
                      </h4>

                      {searchResults.length === 0 ? (
                        <p>Aucune actualité trouvée.</p>
                      ) : (
                        searchResults.map((result) => (
                          <div
                            key={result.id}
                            style={{
                              padding: "10px",
                              marginBottom: "10px",
                              borderBottom: `1px solid ${colors.border}`,
                              cursor: "pointer"
                            }}
                            onClick={() => navigateToInformation(result.id)}
                          >
                            <h5 style={{
                              fontSize: "15px",
                              fontWeight: "600",
                              color: colors.primary,
                              marginBottom: "5px"
                            }}>
                              {truncateText(result.titre, 50)}
                            </h5>
                            <div style={{ display: "flex", alignItems: "center", fontSize: "12px", color: "#666" }}>
                              <i className="fa fa-calendar" style={{ marginRight: "5px" }}></i>
                              {formatDate(result.dateFin)}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  )}
                </div>

                {/* Informations Récentes */}
                <div className="sidebar-widget_1 _recent-posts mt-40">
                  <h3 style={{ color: colors.secondary   }}>Actualités Récentes</h3>

                  {loading ? (
                    <p>Chargement des actualités...</p>
                  ) : informations.length === 0 ? (
                    <p>Aucune information disponible.</p>
                  ) : (
                    currentInformations.map((info) => (
                      <div
                        className="blog1-recent-box mt-16"
                        key={info.id}
                        style={{
                          display: "flex",
                          marginBottom: "20px",
                          borderBottom: `1px solid ${colors.border}`,
                          paddingBottom: "15px",
                          cursor: "pointer",
                          transition: "transform 0.3s ease"
                        }}
                        onClick={() => navigateToInformation(info.id)}
                        onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-3px)"}
                        onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
                      >
                        <div className="recent-thumb" style={{ width: "80px", height: "80px", marginRight: "15px", flexShrink: 0 }}>
                          <img
                            src={info.image ? baseApiUrl.defaults.baseURL + `/image/${info.image}` : `${process.env.PUBLIC_URL}/assets/img/default-image.jpg`}
                            alt={info.titre || "Titre inconnu"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "5px",
                              border: `2px solid ${colors.secondary}`
                            }}
                          />
                        </div>
                        <div className="heading">
                          <span className="date" style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center" }}>
                            <img src={`${process.env.PUBLIC_URL}/assets/img/icons/date1.svg`} alt="date" style={{ width: "14px", marginRight: "5px" }} />
                            {formatDate(info.created)}
                          </span>
                          <h5 style={{ fontSize: "15px", fontWeight: "600", marginTop: "5px", color: colors.tertiary }}>
                            {truncateText(info.titre, 60)}
                          </h5>
                          {info.contenu && (
                            <p style={{ fontSize: "13px", color: "#666", marginTop: "5px" }}>
                              {truncateText(info.contenu, 80)}
                            </p>
                          )}
                        </div>
                      </div>
                    ))
                  )}

                  {/* Pagination */}
                  {informations.length > itemsPerPage && (
                    <div className="pagination-wrapper" style={{ marginTop: "30px" }}>
                      <ReactPaginate
                        previousLabel={<i className="fa fa-angle-left"></i>}
                        nextLabel={<i className="fa fa-angle-right"></i>}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil(informations.length / itemsPerPage)}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        pageLinkClassName={"page-link"}
                        previousLinkClassName={"page-link"}
                        nextLinkClassName={"page-link"}
                        pageClassName={"page-item"}
                        previousClassName={"page-item"}
                        nextClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        disabledClassName={"disabled"}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          listStyle: "none",
                          padding: 0
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer1 />
      <Footer />
    </forum>
  );
}

export default Forum;
